export const generatePathFromText = (text: string) => {
  return String(text)
    .toLowerCase()
    .trim()
    .replace(/[^\w\s]/gi, '')
    .replace(/\s+/g, '-')
    .slice(0, 32)
}
